import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../models';

import { filter, mapTo, Observable, take, tap } from 'rxjs';
import { allResources } from '../selectors';
import { DbService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class ResourcesLoadedGuard implements CanActivate {
  private store = inject<Store<AppState>>(Store<AppState>);
  private dbService = inject(DbService);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    this.dbService.initialize().subscribe();
    return this.store.select(allResources).pipe(
      filter((x) => !x.loading),
      take(1),
      tap((_) => {
        var el = document.getElementById('appLoading');
        if (el) {
          el.parentElement!.removeChild(el);
        }
      }),
      mapTo(true)
    );
  }
}
